import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PolarArea } from 'react-chartjs-2';
import Slider from 'react-input-slider';

const NumericInputSlide = ({ actual }) => {
    const { t } = useTranslation();

    const getInitialSliderValues = () => {
        const savedAnswer = JSON.parse(localStorage.getItem('currentAnswer') || '[]');
        return savedAnswer.selectedButtonGroup6 || { a: 0, b: 0, c: 0, d: 0, e: 0 };
    };

    const [sliderValues] = useState(getInitialSliderValues);
    const { a: sv, b: sv2, c: sv3, d: sv4, e: sv5 } = sliderValues;

    const sweetness = t('taste.sweetness', { returnObjects: true });
    const acidity   = t('taste.acidity',   { returnObjects: true });
    const tannin    = t('taste.tannin',    { returnObjects: true });
    const body      = t('taste.body',      { returnObjects: true });
    const finish    = t('taste.finish',    { returnObjects: true });

    const data = {
        labels: ['', '', '', '', ''],
        datasets: [
            { label: t('taste.acidity_label'),   data: [sv2 + 1, 0, 0, 0, 0], backgroundColor: 'rgba(210, 164, 62, 0.7)',  borderColor: 'transparent', borderWidth: 3 },
            { label: t('taste.tannin_label'),    data: [0, sv3 + 1, 0, 0, 0], backgroundColor: 'rgba(106, 16, 16, 0.7)',   borderColor: 'transparent', borderWidth: 1 },
            { label: t('taste.body_label'),      data: [0, 0, sv4 + 1, 0, 0], backgroundColor: 'rgba(84, 34, 61, 0.7)',    borderColor: 'transparent', borderWidth: 3 },
            { label: t('taste.finish_label'),    data: [0, 0, 0, sv5 + 1, 0], backgroundColor: 'rgba(29, 154, 120, 0.7)',  borderColor: 'transparent', borderWidth: 3 },
            { label: t('taste.sweetness_label'), data: [0, 0, 0, 0, sv + 1],  backgroundColor: 'rgba(167, 149, 129, 0.7)', borderColor: 'transparent', borderWidth: 3 },
        ],
    };
    const options = {
        scales: { r: { angleLines: { display: true, color: 'rgba(255,255,255,1)' }, grid: { color: 'rgba(255,255,255,0.5)' }, suggestedMin: 0, suggestedMax: 3, ticks: { display: false }, pointLabels: { font: { size: 0 } } } },
        plugins: { legend: false, tooltip: { enabled: true, callbacks: { label: (ctx) => ctx.dataset.label } } },
    };

    const rows = [
        { label: t('taste.sweetness_label'), value: sv,  valueText: sweetness[sv]  },
        { label: t('taste.acidity_label'),   value: sv2, valueText: acidity[sv2]   },
        { label: t('taste.tannin_label'),    value: sv3, valueText: tannin[sv3]    },
        { label: t('taste.body_label'),      value: sv4, valueText: body[sv4]      },
        { label: t('taste.finish_label'),    value: sv5, valueText: finish[sv5]    },
    ];

    return (
        <div className="an-slide">
            <h2 className="an-slide-title">{t('taste.title')}</h2>

            <div className="an-sliders">
                {rows.map(({ label, value, valueText }) => (
                    <div key={label} className="an-slider-row">
                        <span className="an-slider-label">{label}</span>
                        <div className="an-slider-track">
                            <Slider axis="x" x={value} xmax={2} />
                        </div>
                        <span className="an-slider-value">{valueText}</span>
                    </div>
                ))}
            </div>

            <div className="an-chart">
                <PolarArea data={data} options={options} />
            </div>
        </div>
    );
};

export default NumericInputSlide;
